"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ImageImports_1 = require("Common/Utils/ImageImports");
var createBluePrintCreator = require("../BluePrintCreator").default;
var PageStateChangeConfirmationModal_1 = require("Common/Modal/PageModals/PageStateChangeConfirmationModal");
var lodash_1 = __importDefault(require("lodash"));
module.exports = function (make, di, projectService, usingFeature, upseller, projectStatusChecker, projectStatusSetter, projectTagManagerModal, telemetry, projectSecurer, PdfExport, projectPreviewer, projectLinkRetriever, user, state, notifyUser, modal, rootDataStore) {
    var bluePrintCreator = di.invoke(createBluePrintCreator);
    var availableActions = {
        share: {
            name: "Share",
            getDisplayName: function () {
                return "Share";
            },
            tooltip: "Share by email and social networks",
            icon: function () {
                return ImageImports_1.Share;
            },
            upsellFeatureFlag: null,
            action: function (project) {
                if (projectStatusChecker.isEnabled(project)) {
                    return state.goToProjectAction("share", project);
                }
                else {
                    return projectStatusChecker.showDisabledWarning();
                }
            },
            permission: "view",
        },
        clone: {
            name: "Clone",
            getDisplayName: function () {
                return "Clone";
            },
            tooltip: "Create a fresh copy of this project",
            icon: function () {
                return ImageImports_1.Clone;
            },
            upsellFeatureFlag: null,
            action: function (project, projectList, origin) {
                return projectService.clone(project, origin);
            },
            permission: "view",
        },
        delete: {
            name: "Delete",
            getDisplayName: function (project) {
                if (!projectService.isTemplate(project)) {
                    return "Delete page";
                }
                else {
                    return "Delete template";
                }
            },
            tooltip: "Permanently delete this project",
            icon: function () {
                return ImageImports_1.Delete;
            },
            upsellFeatureFlag: null,
            action: function (projects, projectList) {
                return (projectService
                    .confirmDelete(projects)
                    .then(function (shouldDelete) {
                    if (shouldDelete) {
                        return projectService.delete(projects);
                    }
                })
                    .then(function (response) {
                    if (response === null || response === void 0 ? void 0 : response.success) {
                        notifyUser.success(response.message);
                        return state.goToDashboard();
                    }
                    else if (response === null || response === void 0 ? void 0 : response.message) {
                        return notifyUser.error(response.message);
                    }
                }));
            },
            permission: "all",
        },
        restore: {
            name: "Restore",
            getDisplayName: function () {
                return "Restore";
            },
            tooltip: "Restore this project to your project list",
            icon: function () {
                return ImageImports_1.Restore;
            },
            upsellFeatureFlag: null,
            action: function (projects, projectList) {
                return projectService.restore(projects).then(function (response) {
                    if (response.success) {
                        notifyUser.success(response.message);
                        if (projectList) {
                            return projectList.refresh();
                        }
                    }
                    else {
                        return notifyUser.error(response.message);
                    }
                });
            },
        },
        preview: {
            name: "Preview",
            getDisplayName: function () {
                return "Preview";
            },
            tooltip: "See the live view of this project",
            icon: function () {
                return ImageImports_1.LargePreview32;
            },
            upsellFeatureFlag: null,
            action: function (project) {
                if (!showDisableAcceptAndQuoteUpseller(project)) {
                    return projectService.preview(project);
                }
            },
            permission: "view",
        },
        analytics: {
            name: "Analytics",
            getDisplayName: function () {
                return "Page analytics";
            },
            tooltip: "See project analytics",
            icon: function () {
                return ImageImports_1.Analytics;
            },
            upsellFeatureFlag: "basic analytics",
            customUpsellOptions: {
                customUpsellMessage: "Learn what your clients care about with detailed information they viewed & clicked.",
                customUpsellVideoLink: "https://www.youtube.com/watch?v=J63WpPlzI_g",
                customUpsellHelpLink: "https://help.qwilr.com/article/156-analytics-insights",
            },
            action: function (project) {
                return state.goToProjectAction("analytics", project);
            },
            permission: "view",
        },
        settings: {
            name: "Settings",
            getDisplayName: function () {
                return "Settings";
            },
            tooltip: "Open project settings",
            event: "Project Settings Viewed",
            icon: function () {
                return ImageImports_1.Settings;
            },
            upsellFeatureFlag: null,
            action: function (project) { },
            permission: "all",
        },
        bluePrint: {
            name: "Blueprint",
            getDisplayName: function () {
                return "Blueprint";
            },
            tooltip: "Utilise the BluePrint API",
            icon: function () {
                return ImageImports_1.Blueprint;
            },
            upsellFeatureFlag: "bluePrintApi",
            action: function (project) {
                return bluePrintCreator(project);
            },
            permission: "edit",
            customUpsellOptions: {
                customUpsellMessage: "Upgrade to mass produce personalized documents via integrations or a CSV upload.",
            },
        },
        archive: {
            name: "Archive",
            getDisplayName: function (project) {
                if (project.isArchived) {
                    return "Unarchive";
                }
                else {
                    return "Archive";
                }
            },
            tooltip: function (project) {
                if (project.isArchived) {
                    return "Unarchive this project";
                }
                else {
                    return "Archive this project";
                }
            },
            icon: function (project) {
                if (!project.isArchived) {
                    return ImageImports_1.Unarchive;
                }
                else {
                    return ImageImports_1.Archive;
                }
            },
            upsellFeatureFlag: null,
            action: function (projects) {
                if (!lodash_1.default.isArray(projects)) {
                    projects = [projects];
                }
                if (lodash_1.default.includes(projects[0].tags, "archived")) {
                    return projects.forEach(function (project) { return project.unarchive(); });
                }
                else {
                    return Promise.resolve()
                        .then(function () {
                        if (projects[0].isBlueprint) {
                            return true;
                        }
                        else {
                            return (0, PageStateChangeConfirmationModal_1.confirmArchiveWithModal)(modal, rootDataStore.userDataStore.useHistoryDataStore);
                        }
                    })
                        .then(function (okToArchive) {
                        if (okToArchive) {
                            return projects.forEach(function (project) { return project.archive(); });
                        }
                    });
                }
            },
            permission: "all",
        },
        star: {
            name: "Star",
            getDisplayName: function (projects) {
                if (!lodash_1.default.isArray(projects)) {
                    projects = [projects];
                }
                if (lodash_1.default.reduce(projects, function (res, project) { return res && lodash_1.default.includes(project.tags, "starred"); }, true)) {
                    return "Unstar";
                }
                else {
                    return "Star";
                }
            },
            tooltip: "Star this project",
            icon: function (projects) {
                if (!lodash_1.default.isArray(projects)) {
                    projects = [projects];
                }
                if (lodash_1.default.reduce(projects, function (res, project) { return res && lodash_1.default.includes(project.tags, "starred"); }, true)) {
                    return ImageImports_1.OldStar;
                }
                else {
                    return ImageImports_1.OldStarUnselected;
                }
            },
            upsellFeatureFlag: null,
            action: function (projects, projectList) {
                if (!lodash_1.default.isArray(projects)) {
                    projects = [projects];
                }
                if (lodash_1.default.reduce(projects, function (res, project) { return res && lodash_1.default.includes(project.tags, "starred"); }, true)) {
                    return projectService.removeTag(projects, projectList, "starred");
                }
                else {
                    return projectService.tag(projects, projectList, "starred");
                }
            },
            permission: "all",
        },
        tag: {
            name: "Tag",
            getDisplayName: function () {
                return "Tag";
            },
            tooltip: "Tag this project",
            icon: function () {
                return ImageImports_1.Tag;
            },
            upsellFeatureFlag: null,
            action: function (projects, projectList, onAction) {
                return projectTagManagerModal.show(projects, projectList).then(function () {
                    if (onAction != null) {
                        return onAction("Tag");
                    }
                });
            },
            permission: "edit",
        },
        disable: {
            name: "Disable",
            getDisplayName: function (projects) {
                if (!lodash_1.default.isArray(projects)) {
                    projects = [projects];
                }
                var isDisabledReducer = function (result, project) { return result && projectSecurer.isDisabled(project); };
                if (lodash_1.default.reduce(projects, isDisabledReducer, true)) {
                    return "Enable";
                }
                else {
                    return "Disable";
                }
            },
            tooltip: "Disable external access",
            icon: function () {
                return ImageImports_1.Disable;
            },
            upsellFeatureFlag: null,
            action: function (projects, projectList) {
                if (!lodash_1.default.isArray(projects)) {
                    projects = [projects];
                }
                var isDisabledReducer = function (result, project) { return result && projectSecurer.isDisabled(project); };
                if (lodash_1.default.reduce(projects, isDisabledReducer, true)) {
                    return projectStatusSetter.enableProjects(projects, projectList);
                }
                else {
                    return projectStatusSetter.disableProjects(projects, projectList);
                }
            },
            permission: "all",
        },
        pdfExport: {
            name: "PDF",
            getDisplayName: function () {
                return "PDF";
            },
            tooltip: "Export to PDF",
            icon: function () {
                return ImageImports_1.PDF2;
            },
            upsellFeatureFlag: null,
            action: function (project) {
                if (!showDisableAcceptAndQuoteUpseller(project)) {
                    var pdfOverlay = make(require("../../../PdfPreviewOverlay/PdfPreviewOverlay").PdfPreviewOverlay, {
                        previewLink: projectPreviewer.getPdfPreviewLink(project),
                        pdfUrl: projectLinkRetriever.getPdfUrlForProject(project),
                        oneTimeTokenUrl: projectLinkRetriever.getOneTimeTokenUrl(project._id, project.links[0].secret),
                    });
                    return pdfOverlay.show();
                }
            },
            permission: "view",
        },
        markTemplate: {
            name: "Mark As Template",
            getDisplayName: function (project) {
                if (!projectService.isTemplate(project)) {
                    return "Convert To Template";
                }
                else {
                    return "Remove From Templates";
                }
            },
            tooltip: function (project) {
                if (!projectService.isTemplate(project)) {
                    return "Make accessible on new project screen";
                }
                else {
                    return "Remove from new projects screen";
                }
            },
            icon: function (project) {
                if (!projectService.isTemplate(project)) {
                    return ImageImports_1.ColorCreateTemplate;
                }
                else {
                    return ImageImports_1.ColorRemoveTemplate;
                }
            },
            upsellFeatureFlag: null,
            action: function (project) {
                if (!projectService.isTemplate(project)) {
                    return projectService.addAsTemplate(project);
                }
                else {
                    return projectService.removeAsTemplate(project);
                }
            },
            permission: "all",
        },
    };
    var showDisableAcceptAndQuoteUpseller = function (project) {
        if (projectService.shouldDisableAcceptAndQuoteAccess(project)) {
            upseller.upsell({
                feature: "accept",
                featureLabel: "Pricing and accept blocks",
            });
            return true;
        }
        else {
            return false;
        }
    };
    availableActions["changeOwner"] = {
        name: "ChangeOwner",
        getDisplayName: function () {
            return "Change Owner";
        },
        tooltip: "Change Owner",
        icon: function () {
            return ImageImports_1.ChangeOwner;
        },
        upsellFeatureFlag: null,
        action: function (projects, projectList) {
            return projectService.changeOwner(projects, projectList);
        },
        permission: "all",
    };
    for (var name in availableActions) {
        var action = availableActions[name];
        (function (name, action) {
            var featureNames = action.$upsellFlags || name;
            var onClick = action.upsellFeatureFlag && !usingFeature(action.upsellFeatureFlag)
                ? function () {
                    var options = {
                        feature: action.upsellFeatureFlag,
                        featureLabel: action.name,
                    };
                    if (action.customUpsellOptions) {
                        lodash_1.default.assign(options, action.customUpsellOptions);
                    }
                    return upseller.upsell(options);
                }
                : (function (action) {
                    return function (project, projectList) {
                        var extraArgs = [];
                        for (var _i = 2; _i < arguments.length; _i++) {
                            extraArgs[_i - 2] = arguments[_i];
                        }
                        if (action.event != null) {
                            if (action.event.name != null) {
                                telemetry.trackOnly(action.event.name, {}, action.event.modifiers);
                            }
                            else {
                                telemetry.trackOnly(action.event);
                            }
                        }
                        return action.action.apply(action, __spreadArray([project, projectList], __read(Array.from(extraArgs)), false));
                    };
                })(action);
            return (availableActions[name].onClick = onClick);
        })(name, action);
    }
    return availableActions;
};
